import React, {Suspense, useEffect, useRef, useState} from 'react';
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as modulesState} from "../Redux/modules";
import {actionsState as projectState} from "../Redux/project";
import * as THREE from "three";
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader';
import { SAOPass } from 'three/examples/jsm/postprocessing/SAOPass.js';
import {getDeltas, getStrLang} from "../Helpers/functions";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
import { Sky } from 'three/examples/jsm/objects/Sky.js';
import MaterialSelect from "./MaterialSelect";
import MaterialDropBox from "./widgets/MaterialDropBox";
import VariantDropBox from "./widgets/VariantDropBox";
import {sendRedrawSimpleEvent} from "../Helpers/Events";

let camera,scene,mouse = new THREE.Vector2(), controls,
    ambientLight, spotLight, spotLight2,
    renderer,raycaster,composer,rp,effectFXAA,saoPass,clock;

const ModuleInfo = ({module,changeModule})=>{

    const dispatch = useDispatch();
    useEffect(()=>{
        if(scene){
            scene.traverse(obj=>{
                if(obj.isGroup && obj.userData.type === 'MODUL'){
                    const parent = obj.parent;
                    parent.remove(obj);
                    parent.add(module.model);
                }
            });
        }
    },[module]);

    const canvas = useRef();

    const [materialCorp,setMaterialCorp] = useState(module.corp);
    const [materialFace,setMaterialFace] = useState(module.face);
    const [materialCloth,setMaterialCloth] = useState(module.cloth);
    const [option,setOption] = useState(module.optionStatus);

    const [materialCorpWnd,setMaterialCorpWnd] = useState(false);
    const [materialFaceWnd,setMaterialFaceWnd] = useState(false);
    const [materialClothWnd,setMaterialClothWnd] = useState(false);

    const [heightFromFloor,setHeightFromFloor] = useState(module.heightFromFloor)
    // console.log('ModuleInfo module',module)
    const handlerHeightFromFloor = event=>{

        // console.log('handlerHeightFromFloor',event.target.value)

        setHeightFromFloor(event.target.value);
        module.heightFromFloor = event.target.value;
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    useEffect(()=>{
        dispatch(modulesState.getPrice());
    },[option,materialCorp,materialFace,materialCloth]);
    const remove = ()=>{
        dispatch(modulesState.remove(module));
        dispatch(modulesState.getPrice());
        dispatch(projectState.setModal(''));
    }


    const close = ()=>{
        dispatch(projectState.setModal(''));
    }


    const corpKeys = module.materials.corp?Object.keys(module.materials.corp):null;
    const corpMaterials = corpKeys?window.materials.corp.filter(m=>corpKeys.find(id=>id===m.userData.ID.toString())):window.materials.corp;

    const faceKeys = module.materials.face?Object.keys(module.materials.face):null;
    const faceMaterials = faceKeys?window.materials.face.filter(m=>faceKeys.find(id=>id===m.userData.ID.toString())):window.materials.face;

    const clothKeys = module.materials.cloth?Object.keys(module.materials.cloth):null;
    const clothMaterials = clothKeys?window.materials.cloth.filter(m=>clothKeys.find(id=>id===m.userData.ID.toString())):window.materials.cloth;

    const setMaterial = (material)=>{
        if(material.name === 'corp'){
            module.corp = material;
            setMaterialCorp(module.corp);
        }
        else if(material.name === 'face'){
            module.face = material;
            setMaterialFace(module.face);
        }
        else if(material.name === 'cloth'){
            module.cloth = material;
            setMaterialCloth(module.cloth);
        }
    }

    const setVariant = (variant)=>{
        changeModule(module,variant);
    }

    useEffect(()=>{
        //const parent = module.parent;
        //const element = module.model.children[0].children[0];
        const onResize = ()=>{
            const width = canvas.current.clientWidth;
            const height = canvas.current.clientHeight;
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width,height);
            //composer.setSize(width,height);
            //effectFXAA.uniforms['resolution'].value.set(1/width,1/height);
        }
        window.addEventListener("resize",onResize);
/*
        const generateFloor = (plan,mat)=>{
            const result = new THREE.Group();
            result.userData.type = "floor";
            //милиметровка
            // const planGmt = new THREE.PlaneBufferGeometry(100,100,1,1);
            // planGmt.attributes.uv.array = planGmt.attributes.uv.array.map(p=>p*100);
            // const mm = new THREE.TextureLoader().load( '/configurator3d/img/mm.jpg',t=>{
            //     t.wrapS = THREE.RepeatWrapping;
            //     t.wrapT = THREE.RepeatWrapping;
            // } );
            const planGmt = new THREE.PlaneBufferGeometry(100,100,100,100);
            const planeMat = new THREE.MeshBasicMaterial({
                color:0xFFFFFF
            });
            const planeMesh = new THREE.Mesh( planGmt, planeMat );
            planeMesh.rotateX(-Math.PI/2);
            planeMesh.receiveShadow = true;
            planeMesh.translateZ(-0.03);
            result.add(planeMesh);
            return result;
        };*/

        const init = ()=>{
            camera = new THREE.PerspectiveCamera(
                40, canvas.current.clientWidth/canvas.current.clientHeight, 0.01, 200 );
            camera.position.set(-5,4,15);
            scene = new THREE.Scene();
            // scene.background = new THREE.Color( 0xf9f9f9 );
            controls = new OrbitControls( camera, canvas.current );
            controls.maxPolarAngle = Math.PI / 2;
            controls.minDistance = 3;
            controls.maxDistance = 14;
            controls.zoomSpeed = .5;


            renderer = new THREE.WebGLRenderer({
                canvas: canvas.current,
                antialias: true,
                powerPreference: 'high-performance',
                preserveDrawingBuffer: true,
                alpha: true
            });
            renderer.setSize( canvas.current.clientWidth, canvas.current.clientHeight );

            renderer.setClearColor(0x000000, 0)
            renderer.toneMappingExposure = .8
            renderer.physicallyCorrectLights = false

            const GammaEncoding = 3007;
            const PCFSoftShadowMap = 2;
            const ACESFilmicToneMapping = 4;
            renderer.autoClear = true;
            renderer.outputEncoding = GammaEncoding;
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = PCFSoftShadowMap;
            renderer.shadowMap.autoUpdate = false;
            renderer.setPixelRatio( window.devicePixelRatio );



            const bb = new THREE.Box3()
            bb.setFromObject(module.model)
            const modelCenter = bb.getCenter()

            controls.target = new THREE.Vector3(modelCenter.x,modelCenter.y,modelCenter.z)

            // controls.target = new THREE.Vector3(0,.5,0);
            controls.update();
            clock = new THREE.Clock();


            scene.add( new THREE.AmbientLight( 0xffffff, .6 ) );

            const directionalLight = new THREE.DirectionalLight( 0xffffff, .1 );
            directionalLight.position.set( -5, 10, 15 ).normalize();
            directionalLight.castShadow = true;
            scene.add( directionalLight );

            const directionalLight2 = new THREE.DirectionalLight( 0xffffff, .3 );
            directionalLight2.position.set( -10, 10, -10 ).normalize();
            directionalLight2.castShadow = true;
            scene.add( directionalLight2 );

            const directionalLight3 = new THREE.DirectionalLight( 0xffffff, .3 );
            directionalLight3.position.set( -10, 10, 10 ).normalize();
            directionalLight3.castShadow = true;
            scene.add( directionalLight3 );

            /*
            ambientLight = new THREE.AmbientLight( 0xffffff, 1 );
            scene.add(ambientLight);

            spotLight = new THREE.SpotLight( 0xffffff, 10);
            spotLight.position.set( -14,20,8 );
            spotLight.castShadow = true;
            spotLight.shadow.camera.near = 0.1;
            spotLight.shadow.camera.far = 2000;
            spotLight.shadow.camera.fov = 50;
            spotLight.shadow.mapSize.width = 2048;
            spotLight.shadow.mapSize.height = 2048;
            // scene.add(spotLight);

            spotLight2 = new THREE.SpotLight( 0xffffff, 10);
            spotLight2.position.set( 34,20,20 );
            spotLight2.castShadow = true;
            spotLight2.shadow.camera.near = 0.1;
            spotLight2.shadow.camera.far = 2000;
            spotLight2.shadow.camera.fov = 50;
            spotLight2.shadow.mapSize.width = 2048;
            spotLight2.shadow.mapSize.height = 2048;
            // scene.add(spotLight2);

            var directionalLight=new THREE.DirectionalLight( 0xffffff, .5 );
            directionalLight.position.set( -340,500,-200 )
            directionalLight.castShadow = true;
            scene.add(directionalLight);

             */

            // console.log('MODEL',module.model);

            scene.add(module.model);
            // scene.add(generateFloor());

            /*
            const sky = new Sky();
            const uniforms = sky.material.uniforms;
            uniforms[ "turbidity" ].value = 10;
            uniforms[ "rayleigh" ].value = 3;
            uniforms[ "mieCoefficient" ].value = 0.005;
            uniforms[ "mieDirectionalG" ].value = 0.8;
            uniforms[ "sunPosition" ].value = new THREE.Vector3(5.0, 20.0, -200.0);
            sky.scale.setScalar( 200);
            scene.add( sky );
            */
            // scene.overrideMaterial = true;
            /*
            renderer = new THREE.WebGLRenderer( {
                canvas: canvas.current,
                antialias: true,
                powerPreference: 'high-performance',
                preserveDrawingBuffer: true,
                alpha: true
            } );
            renderer.setClearColor(0x000000, 0)
            renderer.toneMappingExposure = .5
            // renderer.toneMappingWhitePoint = 15
            renderer.physicallyCorrectLights = false

            const GammaEncoding = 3007;
            const PCFSoftShadowMap = 2;
            const ACESFilmicToneMapping = 1;
            // renderer.autoClear = true;
            renderer.outputEncoding = GammaEncoding;
            // renderer.physicallyCorrectLights = true;
            // renderer.setPixelRatio(1); // handle pixel ratio externally
            renderer.shadowMap.enabled = false;
            renderer.shadowMap.type = PCFSoftShadowMap;
            renderer.shadowMap.autoUpdate = false;
            renderer.toneMapping = ACESFilmicToneMapping;

            renderer.setPixelRatio( window.devicePixelRatio );

             */
            /*renderer.setClearColor( 0xffffff);
            renderer.autoClear = false;
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = THREE.PCFSoftShadowMap;

            renderer.shadowMap.enabled = true;
            renderer.shadowMapSoft = true;

            renderer.shadowCameraNear = 3;
            renderer.shadowCameraFar = camera.far;
            renderer.shadowCameraFov = 50;

            renderer.shadowMapBias = 0.0039;
            renderer.shadowMapDarkness = 0.5;
            renderer.shadowMapWidth = 1024;
            renderer.shadowMapHeight = 1024;*/

            raycaster = new THREE.Raycaster();
            mouse = new THREE.Vector2();
            onResize();

            /*
            composer = new EffectComposer(renderer );
            composer.setSize( canvas.current.clientWidth,canvas.current.clientHeight );

            rp = new RenderPass(scene, camera);
            composer.addPass(rp);
            //
            effectFXAA = new ShaderPass( FXAAShader );
            composer.addPass( effectFXAA );

            saoPass = new SAOPass( scene, camera, false, true );
            composer.addPass( saoPass );
            saoPass.params.saoBias = 0.05;
            saoPass.params.saoBlurRadius = 2;
            saoPass.params.saoIntensity = 0.003;
            saoPass.params.saoKernelRadius = 0.02;*/
        };

        const onClickHandler = event=>{
            // console.log('onClickHandler => module',module)
            const rect = canvas.current.getBoundingClientRect();
            let e = event;
            if(event.changedTouches) e = event.changedTouches[ 0 ];
            const mouse = new THREE.Vector2();
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
            raycaster.setFromCamera( mouse, camera );
            const intersects = raycaster.intersectObjects( [module.model], true );
            let selectedObject = null;
            if ( intersects.length > 0 ){
                selectedObject = intersects[0].object;
            }
            if(selectedObject){
                const root = module;
                if(root.status === 'close') root.status='open';
                else root.status='close';
            }
        }
        canvas.current.addEventListener('click',onClickHandler);

        const animate = ()=>{
            requestAnimationFrame( animate );
            const mixerUpdateDelta = clock.getDelta();
            module.mixer.update(mixerUpdateDelta);
            //scene.overrideMaterial = true;

            renderer.render(scene, camera);
            //composer.render();
        }

        init();
        animate();

        return ()=>{
            window.removeEventListener("resize",onResize);
            canvas.current.removeEventListener('click',onClickHandler);
            //parent.add(element);
        }
    },[]);

    // useEffect(()=>{
    // },[]);

    const toggleOption = ()=>{
        const newStatus = !module.optionStatus;
        if(newStatus && module.option){
            module.optionStatus = newStatus;
            setOption(module.optionStatus);
        }
        else{
            module.optionStatus = false;
            setOption(module.optionStatus);
        }
        dispatch(modulesState.getPrice());
    }
    const modules = useSelector(store=>store.modules.allModules);
    const opt = module.option?modules.find(m=>m.ID == module.option.ID):null;
    const mod = modules.find(m=>m.ID == module.id);
    const variants = mod.VARIANTS.reduce((acc,v)=>{
        const item = modules.find(m=>m.ID == v.ID);
        if(item) acc.push(item);
        return acc;
    },[]);

    // console.log('ModuleInfo mod',mod)

    return <div><div className='modal-bg'></div><div className='module-info'>
    <div className="module-canvas">
        <canvas ref={canvas} id="modul">
        </canvas>
    </div>
    <ModalWrapper
        title={module.name}
        onDelete={()=>remove()}
        onClose={()=>close()}
        >

        <div className="modal-body">
            {mod.ICO && (
                <div className={"module-image"}>
                    <img src={mod.ICO} alt={module.name} />
                </div>
            )}
            {!mod.ICO && (
                <br />
            )}
            {module.heightFromFloor > -1 && (
                <div className="size-block">
                    <h2>{ getStrLang('c3d_Mqhme') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={heightFromFloor} onChange={handlerHeightFromFloor} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
            )}
            <div className={"options-title"}>{ getStrLang('c3d_WlOOy') }</div>
            {(module.corp!==null || module.face!==null) &&
            <div className="modal-section">
                {module.corp!==null &&
                <div className="material-select">
                    <div className="material-select__name">{ getStrLang('c3d_C3q59') }</div>
                    <div className="material-select__select" onClick={()=>setMaterialCorpWnd(true)} style={{backgroundImage: 'url(' + materialCorp.userData.PICT + ')',cursor:'pointer'}}>
                        <span>{materialCorp.userData.NAME}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.78 6">
                            <polygon fill="currentColor" points="8.78 0 4.39 6 0 0 8.78 0"></polygon>
                        </svg>
                    </div>
                </div>
                }
                {materialCorpWnd === true && <MaterialSelect
                    onClose={()=>setMaterialCorpWnd(false)}
                    active={materialCorp}
                    list={corpMaterials}
                    setMaterial={setMaterial}
                    title={ getStrLang('c3d_C3q59') }
                />}


                {module.face!==null &&
                <div className="material-select">
                    <div className="material-select__name">{ getStrLang('c3d_ATjFv') }</div>
                    <div className="material-select__select" onClick={()=>setMaterialFaceWnd(true)} style={{backgroundImage: 'url(' + materialFace.userData.PICT + ')',cursor:'pointer'}}>
                        <span>{materialFace.userData.NAME}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.78 6">
                            <polygon fill="currentColor" points="8.78 0 4.39 6 0 0 8.78 0"></polygon>
                        </svg>
                    </div>
                </div>
                }
                {materialFaceWnd === true && <MaterialSelect
                    onClose={()=>setMaterialFaceWnd(false)}
                    active={materialFace}
                    list={faceMaterials}
                    setMaterial={setMaterial}
                    title={ getStrLang('c3d_ATjFv') }
                />}
            </div>
            }


            {materialCloth &&
            <div className="material-select">
                <div className="material-select__name">{ getStrLang('c3d_cofad') }</div>
                <div className="material-select__select" onClick={()=>setMaterialClothWnd(true)} style={{backgroundImage: 'url(' + materialCloth.userData.PICT + ')',cursor:'pointer'}}>
                    <span>{materialCloth.userData.NAME}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.78 6">
                        <polygon fill="currentColor" points="8.78 0 4.39 6 0 0 8.78 0"></polygon>
                    </svg>
                </div>
            </div>
            }
            {materialClothWnd === true && materialCloth && <MaterialSelect
                onClose={()=>setMaterialClothWnd(false)}
                active={materialCloth}
                list={clothMaterials}
                setMaterial={setMaterial}
                title={ getStrLang('c3d_WgUkQ') }
            />}


            <div className={"options-title"}>{ getStrLang('c3d_vgBBl') }</div>
            {variants.length>1 &&
            <VariantDropBox
                list = {variants}
                active = {mod}
                // title = {mod.REPLACEMENT.NAME}
                title = { getStrLang('c3d_XCCtN') }
                setActive = {setVariant}
            />
            }
            {mod.SIZE.HEIGHT!==null && (
                <div className="size-block">
                    <span className="size-block__name">{ getStrLang('c3d_GNYpa') }</span>
                    <span className="size-block__value">{mod.SIZE.HEIGHT} { getStrLang('c3d_6SHYr') }</span>
                </div>
            )}
            {mod.SIZE.WIDTH!==null && (
                <div className="size-block">
                    <span className="size-block__name">{ getStrLang('c3d_OaSqg') }</span>
                    <span className="size-block__value">{mod.SIZE.WIDTH} { getStrLang('c3d_6SHYr') }</span>
                </div>
            )}
            {mod.SIZE.DEPTH!==null && (
                <div className="size-block">
                    <span className="size-block__name">{ getStrLang('c3d_TFSdp') }</span>
                    <span className="size-block__value">{mod.SIZE.DEPTH} { getStrLang('c3d_6SHYr') }</span>
                </div>
            )}
            {mod.SIZE.DEPTH2!==null && (
                <div className="size-block">
                    <span className="size-block__name">{ getStrLang('c3d_7M1rD') }</span>
                    <span className="size-block__value">{mod.SIZE.DEPTH2} { getStrLang('c3d_6SHYr') }</span>
                </div>
            )}


            {module.option && materialCloth && (
                <div className={"options-title-wrap"}>
                    <div className={"options-title"}>{ getStrLang('c3d_XhQ3A') }</div>
                    <div className={"options-title__option"}>
                        <span>{ getStrLang('c3d_WgUkQ') }</span>
                        <div className={module.optionStatus?"oval-checkbox oval-checkbox_active":"oval-checkbox"}
                        onClick = {toggleOption}
                        >&nbsp;</div>
                    </div>
                </div>
            )}
            {module.option && !materialCloth && (
                <div className={"options-title-wrap"}>
                    <div className={"options-title"}>{ getStrLang('c3d_e4hqF') }</div>
                    <div className={"options-title__option"}>
                        <span>{ getStrLang('c3d_FG3P4') }</span>
                        <div className={module.optionStatus?"oval-checkbox oval-checkbox_active":"oval-checkbox"}
                        onClick = {toggleOption}
                        >&nbsp;</div>
                    </div>
                </div>
            )}
            {/*module.optionStatus && <>
                {opt.SIZE.DEPTH && (
                    <div className="size-block">
                        <span className="size-block__name">{ getStrLang('c3d_TFSdp') }</span>
                        <span className="size-block__value">{opt.SIZE.DEPTH} { getStrLang('c3d_6SHYr') }</span>
                    </div>
                )}
                {opt.SIZE.WIDTH && (
                    <div className="size-block">
                        <span className="size-block__name">{ getStrLang('c3d_OaSqg') }</span>
                        <span className="size-block__value">{opt.SIZE.WIDTH} { getStrLang('c3d_6SHYr') }</span>
                    </div>
                )}
                </>
            */}

        </div>
    </ModalWrapper>
    </div></div>
}

export default ModuleInfo
